<template>
  <div class='addFieldNameDialog'>
    <el-dialog
      v-model="curDialogVisible" 
      center
      :show-close="false"
      :close-on-click-modal="false"
      @closed="escClose">
      <div class="bg">
        <div class="input-box name-box">
          <div class="line"></div>
          <div class="left">Name</div>
          <el-input class="right" placeholder="Display name for the column" v-model="inputName" @input="changeName"></el-input>
        </div>
        <div class="namemesg" v-show="showNameMesg">please enter name for the column</div>
        <div class="input-box field-box">
          <div class="line"></div>
          <div class="left">Field</div>
          <el-input class="right" placeholder="Path of the field in metrics.json" v-model="inputField" @input="changeField"></el-input>
        </div>
        <div class="namemesg" v-show="showFieldMesg">please enter path of the field in metrics.json</div>
        <div class="input-box field-box">
          <div class="line"></div>
          <div class="left">Color</div>
          <el-input class="right" placeholder="Path of the color in metrics.json" v-model="inputColor" @input="changeColor"></el-input>
        </div>
        <div class="namemesg" v-show="showColorMesg">please enter Path of the color in metrics.json</div>
        <!-- <div class="input-box field-box">
          <div class="line"></div>
          <div class="left">PerferMax</div>
          <el-input class="right" placeholder="Is the bigger the better？true or false" v-model="inputPerferMax" @input="changePerferMax"></el-input>
        </div> -->
        <div class="namemesg" v-show="showPerferMaxMesg">please enter true or false</div>
        <div class="btn-box">
          <el-button class="btn btn1" @click="cancelDo">Cancel</el-button>
          <el-button class="btn btn2" @click="confirmDo">Confirm</el-button>
        </div>
      </div>

    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'addFieldNameDialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
   watch: {
    dialogVisible(val) {
      this.curDialogVisible = val;
    },
  },
  data() {
    return {
      curDialogVisible: false,
      inputName: "",
      inputField: "",
      showNameMesg: false,
      showFieldMesg: false,
      inputColor: "",
      showColorMesg: false,
      inputPerferMax: '',
      showPerferMaxMesg: false,
    }
  },
  methods: {
    changeColor() {
      if (!this.inputColor) {
        this.showColorMesg = true;
        return;
      }
      this.showColorMesg = false
    },
    changeName() {
      if (!this.inputName) {
        this.showNameMesg = true;
        return;
      }
      this.showNameMesg = false
    },
    changeField() {
      if (!this.inputField) {
        this.showFieldMesg = true;
        return;
      }
      this.showFieldMesg = false
    },
    changePerferMax() {
      if (this.inputPerferMax.toLocaleLowerCase() != 'true' && this.inputPerferMax.toLocaleLowerCase() != 'false') {
        this.showPerferMaxMesg = true;
        return;
      }
      this.showPerferMaxMesg = false
    },
    escClose() {
      this.$emit("cancelDo")
    },
    cancelDo() {
      this.$emit("cancelDo")
    },
    confirmDo() {
      if (!this.inputName) {
        this.showNameMesg = true;
        return;
      }
      this.showNameMesg = false
      if (!this.inputField) {
        this.showFieldMesg = true;
        return;
      }
      this.showFieldMesg = false
      if (!this.inputColor) {
        this.showColorMesg = true;
        return;
      }
      this.showColorMesg = false
      // if (this.inputPerferMax.toLocaleLowerCase() != 'true' && this.inputPerferMax.toLocaleLowerCase() != 'false') {
      //   this.showPerferMaxMesg = true;
      //   return;
      // }
      this.$emit("confirmDo", {name: this.inputName, field: this.inputField, color: this.inputColor, perfermax: false, source: 3})
      this.inputName = ""
      this.inputField = ""
      this.inputColor = ""
      this.inputPerferMax = ""
    },
  },
  created() {
    
  }
}
</script>
<style lang='less' scoped>

.bg {
  display: flex;
  flex-direction: column;
}

.input-box {
  display: flex;
  align-items: center;
  margin-top: 25px;

  .line {
    width: 5px;
    height: 40px;
    background-color: #FBAD15;
  }
  .left {
    width: 90px;
    margin-left: 24px;
    color: #383838;
    font-size: 14px;
    font-weight: bold;
    // background-color: red;
  }
  .right {
    width: 460px;
  }
}

.namemesg {
  margin-left: 122px;
  font-size: 12px;
  color: red;
}

.btn-box {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 45px;
  padding-right: 40px;

  .btn {
    height: 40px;
    width: 160px;
    border-radius: 20px;
    font-size: 16px;
    font-weight: 500;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .btn1 {
    background-color: #F5F5F5;
    border: 1px solid #A6A6A6;
    color: #A6A6A6;
    margin-right: 20px;

  }
  .btn2 {
    background-color: #0052D9;
    border: 1px solid #0052D9;
    color: #ffffff;
  }
}

:deep(.el-dialog--center .el-dialog__body) {
  padding: 0px 0px 30px;
}

:deep(.el-dialog) {
  border-radius: 8px;
  width: 620px !important;
}
  
</style>